import { useParams } from 'react-router-dom';

export const useDisplayApartmentIds = () => {
  const { Id }: { Id: string } = useParams();
  const displayIds = Id ? Id.split(',') : [];
  return {
    displayIds,
  };
};
